<template>
  <div class="alert" :class="typeClass">
    <div class="alert-content">
      <div class="title">{{ title }}</div>
      <slot/>
    </div>
    <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" v-bind:svg-inline="''" v-bind:class="'icon'" @click="click" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M28.5 9.62L26.38 7.5 18 15.88 9.62 7.5 7.5 9.62 15.88 18 7.5 26.38l2.12 2.12L18 20.12l8.38 8.38 2.12-2.12L20.12 18z"/></svg>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    title: String,
    type: {
      type: String,
      default: "info",
      validator(val: string) {
        return ["info", "success", "warning", "error"].includes(val);
      },
    },
  },
  computed: {
    typeClass() {
      return "is" + this.type[0].toUpperCase() + this.type.substr(1);
    },
  },
  methods: {
    click() {
      this.$emit("click");
    },
  },
});
</script>

<style lang="scss" scoped>
$color-type-info: #31708f;
$color-type-info-bg: #d9edf7;
$color-type-info-border: #bcdff1;

$color-type-warning: #8a6d3b;
$color-type-warning-bg: #fcf8e3;
$color-type-warning-border: #faf2cc;

$color-type-error: #a94442;
$color-type-error-bg: #f2dede;
$color-type-error-border: #ebcccc;

$color-type-success: #2b542c;
$color-type-success-bg: #dff0d8;
$color-type-success-border: #d0e9c6;

.title {
  font-weight: bold;
}
.icon {
  cursor: pointer;
  transition: transform 0.2s ease;
  display: block;
  margin-right: -16px;
  margin-top: -16px;
  opacity: 0.3;
  &:hover {
    transform: scale(1.25);
  }
}
.alert {
  padding: 16px;
  border: 1px solid;
  z-index: 3;
  display: flex;

  &-content {
    flex: 1;
  }

  &.isInfo {
    color: $color-type-info;
    background-color: $color-type-info-bg;
    border-color: $color-type-info-border;
  }
  &.isSuccess {
    color: $color-type-success;
    background-color: $color-type-success-bg;
    border-color: $color-type-success-border;
  }
  &.isWarning {
    color: $color-type-warning;
    background-color: $color-type-warning-bg;
    border-color: $color-type-warning-border;
  }
  &.isError {
    color: $color-type-error;
    background-color: $color-type-error-bg;
    border-color: $color-type-error-border;
  }

  a {
    text-decoration: underline;
  }
}
</style>
